<template>
    <div class="asideBox" >
        <div class="kf" v-show='!isShow' @mouseover.prevent="show" >
            <img src="../../assets/images/kf.png" v-if='!isShow'>
            <span>联系我们</span>
        </div>
        <div class="bay-window" v-show='isShow' @mouseout.prevent="hide">
            <h6 class="site_supervision_phone">监督电话</h6>
            <ul>
                <li>{{site.site_supervision_phone}}</li>
            </ul>
            <h6>客服电话</h6>
            <ul>
                <li>{{site.site_support_phone1}}</li>
                <li>{{site.site_support_phone2}}</li>
                <li v-if='site.site_support_phone3'>{{site.site_support_phone3}}</li>
                <li>客服微信：</li>
                <li style="height:100px"><img :src="site.site_staff_qrcode" style="width:80px;margin-top:10px;" alt=""></li>
                <li>工作时间(工作日)：</li>
                <li>{{site.site_work_time_am}}</li>
                <li style="border:none;">{{site.site_work_time_pm}}</li>
            </ul>
        </div>
    </div>

</template>
<script>
import { mapState } from "vuex";
export default {
    computed: {
        ...mapState({
            site: state => state.user.site
        }),
    },
    data(){
        return {
            isShow:false
        }
    },
    methods:{
        show(){
            this.isShow = true;
        },
        hide(){
            console.log('离开')
            this.isShow = false;

        }
    }
}
</script>
<style lang="stylus" scoped>
.asideBox
    width: 140px;
    height:600px;
    position: fixed;
    right: 0;
    top: 0;
    bottom:0;
    margin:auto;
    z-index: 9;
    .kf
        width 80px
        height 80px
        background #F4F8FC
        text-align center
        margin-top: 300px;
        cursor pointer
        position relative
        z-index 10
        img
            width 36px
            vertical-align middle
            margin-top 12px
        span
            font-size 14px
            display block
            margin auto
            color #666666
            margin-top 6px
.bay-window{
    width: 140px;
    height:600px;
    // margin-top: -120px;
    position: fixed;
    right: 0;
    top: 0;
    bottom:0;
    margin:auto;
    z-index: 9;
    // transform scale(0.8)
    // transform-origin 0% 50%
}

.bay-window .window_phone{
    vertical-align: middle;
    margin-right: 5px;
    color: #000;
    box-shadow 0.5px 1px 2px 0.5px rgba(106, 106, 106, 0.5)
}
.bay-window ul{
    padding: 0 5px;
    background: #Fff;
    border: 1px solid #ededed;
    border-radius:  0 0 4px 4px;
    background #F4F8FC
}
.bay-window ul li{
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 14px ;
    color:#666;
    border-bottom: 1px solid #EDEDED;
}
.bay-window h6 {
    font-size:18px;
    color:#fff;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background #4280FF
}
.site_supervision_phone{
    border-radius 0 8px 0 0;
}

</style>



// WEBPACK FOOTER //
// src/components/common/leftAside.vue